import { t } from '@lingui/core/macro';
import { SearchAggregationDateInterval } from 'shared/domains/apollo/generated/types';
export function intervalTranslations(interval) {
    const translations = {
        [SearchAggregationDateInterval.Day]: t({
            message: 'Day',
            comment: 'Insights: Date histogram interval',
        }),
        [SearchAggregationDateInterval.Month]: t({
            message: 'Month',
            comment: 'Insights: Date histogram interval',
        }),
        [SearchAggregationDateInterval.Quarter]: t({
            message: 'Quarter',
            comment: 'Insights: Date histogram interval',
        }),
        [SearchAggregationDateInterval.Week]: t({
            message: 'Week',
            comment: 'Insights: Date histogram interval',
        }),
        [SearchAggregationDateInterval.Year]: t({
            message: 'Year',
            comment: 'Insights: Date histogram interval',
        }),
    };
    return translations[interval];
}
